module.exports = __webpack_public_path__ + "assets/zhishichanquan.fc2784c2.svg";